<template>
    <v-card class="main-card mx-auto" width="100%" max-width="400px">
        <v-list-item two-line>
            <v-list-item-content>
                <v-list-item-title class="text-h5" v-text="poiName">
                </v-list-item-title>
                <!-- <v-list-item-subtitle v-if="this.mainUi.valueUpdatedAt">Última atualização: {{ this.mainUi.valueUpdatedAt | dataBr }} </v-list-item-subtitle> -->
            </v-list-item-content>
        </v-list-item>
        <UiValueAutoload v-for="uiId in mobileUis" :id="uiId" :key="uiId" />
        <v-row>
            <v-col cols="6" v-if="this.signalUi.value">
                <v-row>
                    <v-col cols="1">&nbsp;</v-col>
                    <v-col cols="2">
                        <v-icon>{{ this.signalUi.icon }}</v-icon>
                    </v-col>
                    <v-col cols="8">
                        {{ this.signalUi.value }}
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="6" v-if="this.powerUi.desc">
                <v-row>
                    <v-col cols="1">&nbsp;</v-col>
                    <v-col cols="2">
                        <v-icon :color="this.powerUi.iconColor">{{ this.powerUi.icon }}</v-icon>
                    </v-col>
                    <v-col cols="8">
                        {{ this.powerUi.desc }}
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="6" v-if="this.monConUi.desc">
                <v-row>
                    <v-col cols="1">&nbsp;</v-col>
                    <v-col cols="2">
                        <v-icon :color="this.monConUi.iconColor">{{ this.monConUi.icon }}</v-icon>
                    </v-col>
                    <v-col cols="8">
                        {{ this.monConUi.desc }}
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="6" v-if="this.mainTimestampUi.desc">
                <v-row>
                    <v-col cols="1">&nbsp;</v-col>
                    <v-col cols="2">
                        <v-icon :color="this.mainTimestampUi.iconColor">{{ this.mainTimestampUi.icon }}</v-icon>
                    </v-col>
                    <v-col cols="8">
                        {{ this.mainTimestampUi.desc }}
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">&nbsp;</v-col>
        </v-row>
        <v-divider></v-divider>
        <v-card-actions>
            <v-btn text>
                UIS
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { EventBus } from "@/event-bus";
import moment from "moment";
import { requestTools } from "../mixins/requestTools.js";
import { dateTimeTools } from "../mixins/dateTimeTools.js";
import { signalLevelTools } from "../mixins/signalLevelTools.js";
import { appCaller } from "../mixins/appCaller";
import { DatetimeLayout } from "../services/DatetimeLayout";
import { InstanceConfigs } from "../services/InstanceConfigs";
import { appConfigs } from "../../app-configs.js";
import UiValueAutoload from '@/components/UiValueAutoload';

export default {
    name: "Poi",

    components: {
        UiValueAutoload,
    },

    props: {
        poiId: Number,
        poiName: String
    },

    mixins: [requestTools, dateTimeTools, signalLevelTools, appCaller],

    data: function () {
        return {
            title: null,
            mainUiId: null,
            mobileUis: null,
            mainUi: {
                value: "",
                valueUpdatedAt: "",
                icon: "",
                iconColor: "#666666",
                um: "",
                desc: ""
            },
            signalUi: {
                value: "",
                valueUpdatedAt: "",
                icon: "",
                iconColor: "#666666",
                um: "",
                desc: ""
            },
            monConUi: {
                value: "",
                valueUpdatedAt: "",
                icon: "",
                iconColor: "#666666",
                um: "",
                desc: ""
            },
            powerUi: {
                value: "",
                valueUpdatedAt: "",
                icon: "",
                iconColor: "#666666",
                um: "",
                desc: ""
            },
            mainTimestampUi: {
                value: "",
                valueUpdatedAt: "",
                icon: "",
                iconColor: "#666666",
                um: "",
                desc: ""
            },
            uis: [],
            instanceConfigsSrv: null,
            timeoutHandlerLoop: null
        };
    },

    created: function () {
        EventBus.$emit("eventPageLoad", { name: "POI" });
        this.instanceConfigsSrv = new InstanceConfigs();
    },

    mounted: function () {
        //Atualiza informações da tela quando evento for disparado.
        this.appCallerListenEventByLevel(this.$updNowLevels.level1, function () {
            //Previne muitos eventos seguidos num curto espaço de tempo.
            if (this.timeoutHandlerLoop) {
                clearTimeout(this.timeoutHandlerLoop);
            }
            this.timeoutHandlerLoop = setTimeout(() => {
                this.loop();
            }, 2000);
        }.bind(this));
    },

    afterCreate: function () { },

    beforeCreate: function () { },

    beforeDestroy: function () {
    },

    filters: {
        dataBr(value) {
            return dateTimeTools.methods.usToBr(value);
        }
    },

    methods: {

        loop: async function () {
            await this.loadPoi();
            await this.loadUis();
            if (this.mainUiId) {
                this.loadMainUi();
                await this.loadMainUiImageCond();
            }
            this.loadSignalUi();
            this.loadPowerUi();
            this.loadMonConUi();
            this.loadMainTimestampUi();
        },

        loadPoi: async function () {
            const url = process.env.VUE_APP_ROOT_API + "/poi/listByIds/" + this.poiId;
            const pois = await this.requestGet(url);
            if (!pois[0]) {
                return;
            }
            const poi = pois[0];
            this.title = poi.title;
            this.mainUiId = poi.mainUiId;
            this.mobileUis = poi.mobileUis;
        },

        loadUis: async function () {
            const url = process.env.VUE_APP_ROOT_API + "/ui/list/" + this.poiId + "";
            const uis = await this.requestGet(url);
            if (!uis) {
                this.uis = [];
                return;
            }
            this.uis = uis;
        },

        loadMainUi: function () {
            let mainUiList = this.uis.filter((ui) => {
                return parseInt(ui.id) === parseInt(this.mainUiId);
            });

            if (!mainUiList[0]) {
                return;
            }

            this.mainUi = mainUiList[0];
        },

        loadMainUis: function () {
            let mainUiList = this.uis.filter((ui) => {
                return parseInt(ui.id) === parseInt(this.mainUiId);
            });

            if (!mainUiList[0]) {
                return;
            }

            this.mainUi = mainUiList[0];
        },

        // loadSignalUiOld: function () {
        //     let uiList = this.uis.filter((ui) => {
        //         return ui
        //             .tag
        //             .toString()
        //             .search(process.env.VUE_APP_LEVEL_SIGNAL_TAG_ID) !== -1;
        //     });

        //     if (!uiList[0]) {
        //         return;
        //     }

        //     this.signalUi = uiList[0];
        //     this.signalUi.icon = this.getIconByValue(this.signalUi.value);
        // },

        loadSignalUi: function () {
            this.signalUi = {};
            this.signalUi.icon = "";

            const parts = process.env.VUE_APP_LEVEL_SIGNAL_TAG_ID.toString().split(",");
            for (const i in parts) {
                const part = parts[i].toString().trim();
                for (const j in this.uis) {
                    const ui = this.uis[j];
                    if (ui.tag.toString().search(part) !== -1) {
                        this.signalUi = ui;
                        this.signalUi.icon = this.getIconByValue(this.signalUi.value);
                        return;
                    }
                }
            }
        },

        loadMonConUiOld: function () {
            let uiList = this.uis.filter((ui) => {
                return ui
                    .tag
                    .toString()
                    .search(process.env.VUE_APP_MON_CON_TAG_ID) !== -1;
            });

            if (!uiList[0]) {
                return;
            }

            this.monConUi = uiList[0];

            this.monConUi.icon = 1 === parseInt(this.monConUi.value)
                ? "mdi-access-point-check"
                : "mdi-access-point-off";

            this.monConUi.iconColor = 1 === parseInt(this.monConUi.value)
                ? "#61bd45"
                : "#e6544d";

            this.monConUi.desc = 1 === parseInt(this.monConUi.value)
                ? "Conexão OK"
                : "Sem Conexão";
        },

        loadMonConUi: function () {
            this.monConUi = {};
            this.monConUi.icon = "";
            this.monConUi.iconColor = "";
            this.monConUi.desc = "";
            const parts = process.env.VUE_APP_MON_CON_TAG_ID.toString().split(",");
            for (const i in parts) {
                const part = parts[i].toString().trim();
                for (const j in this.uis) {
                    const ui = this.uis[j];
                    if (ui.tag.toString().search(part) !== -1) {
                        this.monConUi = ui;
                        this.monConUi.icon = 1 === parseInt(this.monConUi.value)
                            ? "mdi-access-point-check"
                            : "mdi-access-point-off";

                        this.monConUi.iconColor = 1 === parseInt(this.monConUi.value)
                            ? "#61bd45"
                            : "#e6544d";

                        this.monConUi.desc = 1 === parseInt(this.monConUi.value)
                            ? "Conexão OK"
                            : "Sem Conexão";
                        return;
                    }
                }
            }
        },

        loadMainTimestampUi: async function () {
            let uiList = this.uis.filter((ui) => {
                return ui.mainUiTimestamp === parseInt(1);
            });

            if (!uiList[0]) {
                return;
            }

            this.mainTimestampUi = uiList[0];
            this.mainTimestampUi.icon = "mdi-clock";

            const dtLayout = this.loadMainTimestampUiGetLayout();

            if (!dtLayout) {
                return;
            }

            this.mainTimestampUi.desc = this.loadMainTimestampUiParseDate(
                dtLayout,
                this.mainTimestampUi.value
            );

            //this.mainTimestampUi.desc = this.detectDateFormat(this.mainTimestampUi.value);
        },

        loadMainTimestampUiGetLayout: function () {

            const instanceName = this.instanceConfigsSrv.getConfig("VM_INSTANCE_NAME");
            const ids = appConfigs.dtTagCnf.filter((item) => {
                return item.instance === instanceName
                    && item.tag === this.mainTimestampUi.tag;

            });

            if (!ids || !ids[0]) {
                return false;
            }

            return ids[0].layout;
        },

        loadMainTimestampUiParseDate: function (idLayout, value) {
            const dtl = new DatetimeLayout(this.$datetimeLayouts, idLayout, value);
            return dtl.getDatetime();
        },

        // loadPowerUiOld: function () {

        //     const titleParts = process.env.VUE_APP_POWER_TITLE_IDS.split(",");

        //     //Busca pela primeira parte
        //     let uiList = this.uis.filter((ui) => {
        //         return ui.title.toString()
        //             .search(titleParts[0]) !== -1;
        //     });

        //     //Busca caso encontre mais do que uma, busca pela segunda
        //     if (uiList.length > 1 && titleParts[1]) {
        //         uiList = this.uis.filter((ui) => {
        //             return ui.title.toString()
        //                 .search(titleParts[1]) !== -1;
        //         });
        //     }

        //     if (!uiList[0]) {
        //         return;
        //     }

        //     this.powerUi = uiList[0];

        //     this.powerUi.icon = 1 === parseInt(this.powerUi.value)
        //         ? "mdi-lightning-bolt-circle"
        //         : "mdi-power-plug-off-outline";

        //     this.powerUi.iconColor = 1 === parseInt(this.powerUi.value)
        //         ? "#61bd45"
        //         : "#e6544d";

        //     this.powerUi.desc = 1 === parseInt(this.powerUi.value)
        //         ? "ON"
        //         : "OFF";
        // },

        loadPowerUi: function () {
            this.powerUi = {};
            this.powerUi.icon = "";
            this.powerUi.iconColor = "";
            this.powerUi.desc = "";
            const parts = process.env.VUE_APP_POWER_TITLE_IDS.toString().split(",");
            for (const i in parts) {
                const part = parts[i].toString().trim();
                for (const j in this.uis) {
                    const ui = this.uis[j];
                    if (ui.tag.toString().search(part) !== -1) {
                        this.powerUi = ui;
                        this.powerUi.icon = 1 === parseInt(this.powerUi.value)
                            ? "mdi-lightning-bolt-circle"
                            : "mdi-power-plug-off-outline";
                        this.powerUi.iconColor = 1 === parseInt(this.powerUi.value)
                            ? "#61bd45"
                            : "#e6544d";
                        this.powerUi.desc = 1 === parseInt(this.powerUi.value)
                            ? "ON"
                            : "OFF";
                        return;
                    }
                }
            }
        },

        showMainUiImagCond(image) {
            this.mainUi.icon = image;
            this.forceMainUiUpdate();
        },

        async loadMainUiImageCond() {

            if (!this.mainUi.id) {
                return;
            }

            if (!this.mainUi.id || (this.mainUi.value + "").trim() == "") {
                return;
            }

            const url = process.env.VUE_APP_ROOT_API + "/uicondexec/" + this.mainUi.id + "/" + this.mainUi.value;
            const conds = await this.requestGet(url);
            for (let i in conds) {
                const cond = conds[i];
                if (0 === parseInt(cond.isTrue) || cond.image === "") {
                    continue;
                }
                this.showMainUiImagCond(cond.image);
            }
            return "";
        },

        parseDateTime: function (dateTimeUs) {
            return moment(dateTimeUs).format("DD-MM-Y HH:mm:ss");
        },

        makeValue: function (elem) {
            return `${elem.value} (${elem.tag})`;
        },

        makeItem: function (elem) {
            return {
                icon: true,
                id: elem.id,
                title: elem.title,
                tag: "TAG" + elem.tag,
                value: this.makeValue(elem),
                inAlarm: elem.inAlarm,
                image: "",
                avatar: ""
            };
        },

        forceMainUiUpdate() {
            this.mainUi = JSON.parse(JSON.stringify(this.mainUi));
        },

        remakeJson(obj) {
            return JSON.parse(JSON.stringify(obj));
        }
    }
};
</script>

<style>
.main-card {
    margin-top: 5px;
}

.ui-um {
    font-size: 10px;
}
</style>
